import React, { Component } from "react";
import { connect } from "react-redux";

import { postServerDataWithTypes } from "../../../action/common_action";
import { ANY_ERROR } from "../../../action/user_action_types";
import { CAMPAIGN_DATA_OF_USER } from "../../../action/salesUser_action_types";

import Header from "../common/AuthHeader";
import SalesUserSideMenu from "../../../menu/SalesUserSideMenu";
import { history } from "../../../history/history";
import Pagination from "../../common/Pagination";
import { axiosInstnace, getLocalData } from "../../../util/util";
import { endPoints } from "../../../config";
import Modal from "./requestNonFCTCode";
import moment from "moment";

class CampaignListComp extends Component {
  constructor(props) {
    super(props);
    //set initial state
    this.state = {
      salesUserInfo: getLocalData("salesUserInfo"),
      page: 1,
      limit: 10,
      addCoupon: false,
      totalRecords: 0,
      campaignsData: [],
      silver: {},
      gold: {},
      targetAmountAcheieved: 0,
      totalCamp: 0,
      grade: 0,
    };
  }

  //Get Campaign Data
  componentDidMount = async () => {
    let { page } = this.state;
    let { salesUserInfo } = this.state;
    let data = {
      email: salesUserInfo.email,
      //   page
    };
    let data1 = await axiosInstnace.post(
      endPoints.getcampaignsbasedondsa,
      data
    );
    let {
      grade,
      targetAmountAcheieved,
      silver,
      gold,
      totalCamp,
    } = data1.data.data;
    this.setState({
      silver,
      gold,
      targetAmountAcheieved,
      totalCamp,
      grade,
    });
    this.getCampignsData(page);
  };
  hideShowCoupon = (e) => {
    this.setState({
      addCoupon: !this.state.addCoupon,
    });
  };

  //Fetching Campign Data from backend
  getCampignsData = async (page) => {
    let { salesUserInfo } = this.state;
    let data = {
      email: salesUserInfo.email,
      page,
    };
    let nonFCTCodes = await axiosInstnace.post(endPoints.getNonFCTCodeRequested, data);
    this.setState({
      campaignsData: nonFCTCodes.data.data,
      totalRecords: nonFCTCodes.data.count
    });
  };

  //Go to Route bassed on path
  goToRoute = (name, data, path) => {
    history.push(path, { [name]: data });
  };

  render() {
    let { campaignsData, totalRecords, page, limit } = this.state;
    let indexNum = (page - 1) * limit;
    return (
      <div className="main_wrapper">
        <SalesUserSideMenu {...this.props} />
        <div className="dashboard_right_wrapper">
          <div className="right_wrapper_inner">
            <Header
              silver={this.state.silver}
              gold={this.state.gold}
              targetAmountAcheieved={this.state.targetAmountAcheieved}
              totalCamp={this.state.totalCamp}
              grade={this.state.grade}
            />{" "}
            <div className="dash_content_wrapper">
              <div className="content_wrapper_inner">
                {campaignsData && campaignsData.length > 0 ? (
                  <div className={`camp_wrapper`}>
                    <div className="running_cap_head">
                      <h2 className="camp_head">Non FCT Code List</h2>
                      {
                        <div className="camp_right">
                          <div className="create_camp_btn">
                            <button onClick={this.hideShowCoupon}>
                              REQUEST NON FCT Code
                            </button>
                          </div>
                        </div>
                      }
                    </div>
                    <div className="camp_listing_wrapper">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Request Date</th>
                            <th>Proposed Amount</th>
                            <th>Non FCT Code</th>
                            <th>Non FCT Code Amount</th>
                            <th>Non FCT Code Expiry Date</th>
                            <th>Request ID</th>
                            <th>Request Expiry Date</th>
                            <th>Description</th>
                          </tr>
                        </thead>
                        <tbody>
                          {campaignsData.map((campaign, index) => {
                            indexNum++;
                            return (
                              <tr key={index}>
                                <td>{indexNum}</td>
                                <td>
                                  {moment(campaign.date).format("DD MMM YYYY")}
                                </td>
                                <td>{campaign.propValue}</td>
                                <td>{campaign.nonFCTCode}</td>
                                <td>{campaign.nonFCTCodeAmount}</td>
                                <td>{campaign.validUntil && moment(campaign.expiryAt).format("DD MMM YYYY")}</td>
                                <td>{campaign._id}</td>
                                <td>{campaign.expiryAt && moment(campaign.expiryAt).format("DD MMM YYYY")}</td>
                                <td>{campaign.justification}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      <div className="paginationTable">
                        {totalRecords >= 10 && (
                          <Pagination
                            getAllData={this.getCampignsData}
                            totalRecords={totalRecords}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className={`bookcampaign`}>
                    <div>
                      <img src="../../assets/images/radio.png" />
                    </div>
                    <div className="book_camp_para">
                      <p>It seems like you don't requested any non FCT Codes yet</p>
                    </div>
                    {
                      <div className="camp_right">
                        <div className="create_camp_btn">
                          <button onClick={this.hideShowCoupon}>
                            REQUEST NON FCT Code
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                )}
                {this.state.addCoupon && (
                  <Modal
                    isShowing={true}
                    hide={this.hideShowCoupon}
                    admin={{}}
                  ></Modal>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    campaignsData: state.sales.get("campaignsDataOfUser"),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSalesUserCampaign: (url, data, type) =>
      dispatch(postServerDataWithTypes(url, data, type)),
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CampaignListComp);



// WEBPACK FOOTER //
// ./web/components/salesUser/campaign/nonfctcode.jsx